import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function DataTable({ className, ...props }) {
    return _jsx("div", { className: clsx("overflow-x-auto", className), ...props });
}
export function Table({ className, ...props }) {
    return _jsx("table", { className: clsx("w-full text-sm", className), ...props });
}
export function TableHead({ className, ...props }) {
    return _jsx("thead", { className: clsx("text-xs uppercase opacity-60", className), ...props });
}
export function TableBody({ className, ...props }) {
    return _jsx("tbody", { className: clsx("divide-y divide-white/10", className), ...props });
}
export function TableRow({ className, ...props }) {
    return _jsx("tr", { className: clsx("align-top", className), ...props });
}
export function TableHeaderCell({ className, ...props }) {
    return _jsx("th", { className: clsx("py-2 pr-4 text-left", className), ...props });
}
export function TableCell({ className, ...props }) {
    return _jsx("td", { className: clsx("py-2 pr-4", className), ...props });
}
